
import React from 'react';

const Career = () => (
  <div className="page_wrapper">
    <h2>Career Us</h2>
    <p>This is the Career page. Content coming soon.</p>
  </div>
);

export default Career;
